export const tablet = '@media screen and (max-width: 1000px)';
export const mobile = '@media screen and (max-width: 500px)';